import React from 'react';
import { Box, SxProps } from '@mui/material';
import { useGeneralAdaptive } from 'shared/hooks/useGeneralAdaptive';

export default function PagePaddingWrapper({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: SxProps;
}) {
  const { generalPaddingX, generalPaddingY } = useGeneralAdaptive();

  return (
    <Box
      className="PagePaddingWrapper"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexGrow: 1,
        px: generalPaddingX,
        py: generalPaddingY,
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: 1440,
          flexGrow: 1,
          width: 1,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
